document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-hbca-learn-section]').forEach((section) => {
    const track = section.querySelector('[data-hbca-learn-track]');
    const previous = section.querySelector('[data-hbca-learn-prev]');
    const next = section.querySelector('[data-hbca-learn-next]');

    if (track && previous && next) {
      const getScrollAmount = () => {
        const firstCard = track.querySelector('.hbca-class-card');
        if (!firstCard) return Math.max(track.clientWidth * 0.8, 320);

        const styles = window.getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap || 0);
        return firstCard.getBoundingClientRect().width + gap;
      };

      const updateButtons = () => {
        const maxScroll = Math.max(track.scrollWidth - track.clientWidth - 2, 0);
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maxScroll;
      };

      previous.addEventListener('click', () => {
        track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });

      next.addEventListener('click', () => {
        track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
    }

    const openButtons = section.querySelectorAll('[data-hbca-modal-open]');
    const modals = section.querySelectorAll('[data-hbca-modal]');
    let lastTrigger = null;

    const closeModal = (modal) => {
      if (!modal) return;
      modal.classList.remove('is-open', 'is-form-view');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('hbca-modal-open');

      if (lastTrigger) {
        lastTrigger.focus();
        lastTrigger = null;
      }
    };

    const openModal = (type, trigger) => {
      const modal = section.querySelector(`[data-hbca-modal="${type}"]`);
      if (!modal) return;

      lastTrigger = trigger;
      modal.classList.add('is-open');
      modal.classList.remove('is-form-view');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('hbca-modal-open');

      window.setTimeout(() => {
        const close = modal.querySelector('[data-hbca-modal-close]');
        if (close) close.focus();
      }, 50);
    };

    openButtons.forEach((button) => {
      button.addEventListener('click', () => {
        openModal(button.dataset.hbcaModalOpen, button);
      });
    });

    modals.forEach((modal) => {
      modal.querySelectorAll('[data-hbca-modal-close]').forEach((button) => {
        button.addEventListener('click', () => closeModal(modal));
      });

      const nextButton = modal.querySelector('[data-hbca-form-next]');
      const backButton = modal.querySelector('[data-hbca-form-back]');

      if (nextButton) {
        nextButton.addEventListener('click', () => {
          modal.classList.add('is-form-view');
          window.setTimeout(() => {
            const firstInput = modal.querySelector('.hbca-edu-modal__panel--form input:not([type="hidden"])');
            if (firstInput) firstInput.focus();
          }, 460);
        });
      }

      if (backButton) {
        backButton.addEventListener('click', () => {
          modal.classList.remove('is-form-view');
        });
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const openModalElement = section.querySelector('.hbca-edu-modal.is-open');
      if (openModalElement) closeModal(openModalElement);
    });
  });
});
